import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  bordered?: boolean;
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = '',
  hover = false,
  bordered = false
}) => {
  return (
    <div 
      className={`
        bg-white rounded-2xl shadow-lg overflow-hidden
        ${hover ? 'transform transition-all duration-300 hover:-translate-y-1 hover:shadow-xl' : ''}
        ${bordered ? 'border border-gray-100' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;